import React from 'react';
import { FormHelperText, FormLabel, Stack } from '@mui/material';
import showdown from 'showdown';
import { VariableData } from './index';

const converter = new showdown.Converter();

export default function PageVariable({ tag, children }: { tag: VariableData; children: React.ReactNode }) {
    return (
        <Stack direction={'column'} key={tag.uid + '-variables-color-picker'}>
            <FormLabel>{tag.name}</FormLabel>
            {children}
            <FormHelperText
                className={'markdown-holder'}
                dangerouslySetInnerHTML={{
                    __html: converter.makeHtml(tag.description),
                }}
            />
        </Stack>
    );
}
